// @flow

import { App } from 'common/app'
import { onUserSet } from 'common/listeners/on-user-set'
import { createRouter } from 'common/router'

import { ROUTES } from './pages/routes'

const router = createRouter(ROUTES)

const app: App = new App({
  documentReadyListeners: [router.runCurrentPageScript],
  onUserSetListener: () => onUserSet(router.pageData?.VISIT_TAG, router.pageData?.onUserSetCallback),
})

window.app = app

export { app }
